import { useRef } from "react"
import { VisuallyHidden } from "@react-aria/visually-hidden"
import styled from "@emotion/styled"

import { useConsole } from "contexts/Console"

import { installation } from "components/roller/cards/styles"
import BeautyshotPush from "components/cards/beautyshot-card/BeautyshotCard"

import Image from "components/media/ImageCLD"
import FigCaption, { suggestionCardStyle } from "components/figcaption/FigCaption"

const CardContainer = styled.li`
  cursor: pointer;
  position: relative;

  figure {
    ${installation}
    pointer-events: none;
    width: 100%;
    display: grid;

    img {
      display: block;
    }

    & picture,
    & img {
      grid-row: 1;
      grid-column: 1;
    }

    figcaption {
      ${suggestionCardStyle};
      position: absolute;
    }
  }
`

const OpenButton = styled.div`
  inset: auto 3em 3em auto;
  position: absolute;
`

export default function Card({ image_cld: image, fig_caption_ref, popin_fig_caption_ref, ...props }) {
  const ref = useRef()

  function onClick() {
    ref.current.click()
  }

  const fig_caption = fig_caption_ref?.length ? fig_caption_ref[0].fig_caption : null
  const popin_fig_caption = popin_fig_caption_ref?.length ? popin_fig_caption_ref[0].fig_caption : null

  return (
    <CardContainer onClick={onClick}>
      <figure>
        <Image {...image} sizes='(min-width: 48rem) 33vw, 50vw' />
        {fig_caption?.caption?.length && <FigCaption {...fig_caption} />}
      </figure>
      <OpenButton>
        <BeautyshotPush {...props} ref={ref} fig_caption={popin_fig_caption} />
      </OpenButton>
      <VisuallyHidden>{props.label}</VisuallyHidden>
    </CardContainer>
  )
}
